/**
 * @fileoverview Initializes the Quotes carousel (Swiper) for each Quotes section.
 *
 * Swiper is a vendored asset loaded with `defer`, so it may not be ready when this file
 * first runs. `init()` guards on `window.Swiper` and, if absent, retries on the next
 * animation frame until the bundle finishes loading. Each section is initialized
 * independently (scoped `el`/nav/pagination) so multiple Quotes sections never clash,
 * and Shopify theme-editor lifecycle events rebuild/tear down instances cleanly.
 */

(function () {
  const instances = new WeakMap();

  function initSection(section) {
    if (!window.Swiper) return false;
    if (instances.has(section)) return true;

    const container = section.querySelector('.quotes__swiper');
    if (!container) return true;

    const swiper = new window.Swiper(container, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 40,
      pagination: {
        el: section.querySelector('.quotes__pagination'),
        clickable: true,
      },
      navigation: {
        prevEl: section.querySelector('.quotes__arrow--prev'),
        nextEl: section.querySelector('.quotes__arrow--next'),
      },
    });

    instances.set(section, swiper);
    return true;
  }

  function destroySection(section) {
    const swiper = instances.get(section);
    if (swiper) {
      swiper.destroy(true, true);
      instances.delete(section);
    }
  }

  function initAll() {
    const sections = document.querySelectorAll('.quotes');
    if (!sections.length) return;

    // Swiper's deferred bundle may still be evaluating — retry until it's available.
    if (!window.Swiper) {
      requestAnimationFrame(initAll);
      return;
    }

    sections.forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor support: re-init on load/reorder, tear down on unload.
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.quotes');
    if (section) initAll();
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector('.quotes');
    if (section) destroySection(section);
  });
})();
